const serverProtocol = process.env.NODE_ENV==='production'? window.location.protocol : 'http:';
const serverHost = process.env.NODE_ENV==='production'? window.location.host : 'localhost:80';
const serverHostname = process.env.NODE_ENV==='production'? window.location.hostname : 'localhost';
const serverPort = process.env.NODE_ENV==='production'? window.location.port : '80';

export default {
  title: "Enfyo App",
  company_producer: "Enfasys Ingeniería S.L",
  //TODO: auto check ports and address for production and development environments
  viewName: "Home",
  devEnv: process.env.NODE_ENV!=='production'?true:false,
  apiURL: `${serverProtocol}//${serverHost}/api`,
  //apiURL: 'http://localhost:8080/api',
  appURL: `${serverProtocol}//${serverHost}`, 
  //appURL: 'http://localhost:8090',
  //seconds from expiry to try keepalive if activity detected, 
  //shall be minor than expiry timelapse from Backend
  secsToKA: 7200, 
  serverHostname,
  serverPort,
  serverProtocol,
};
